import { get } from 'lodash'
import { emailOrPhoneRequired, required } from 'utils/validation'


const validate = (values, props) => {
  const isAssessorDetailsMandatory = get(props, 'isAssessorDetailsMandatory')

  const isAssessorManagementEnabled = get(props, 'isAssessorManagementEnabled')

  const errors = {
    helpers: { category: required(get(values, 'helpers.category')) },
    activityCategory: { id: required(get(values, 'activityCategory.id')) },
    projectLocationType: { value: required(get(values, 'projectLocationType.value')) },
    locationDetail: required(get(values, 'locationDetail')),
    startDate: required(get(values, 'startDate')),
    endDate: required(get(values, 'endDate')),
    goal: required(get(values, 'goal'))
  }

  if (isAssessorDetailsMandatory && !isAssessorManagementEnabled) {
    const emailOrPhoneCheck = emailOrPhoneRequired(get(values, 'assessorEmail'), get(values, 'assessorPhone'))

    errors.assessorName = required(get(values, 'assessorName'))
    errors.assessorEmail = emailOrPhoneCheck
    errors.assessorPhone = emailOrPhoneCheck

  } else if (isAssessorManagementEnabled) {
    const isNoneOfTheseSubCategory = get(values, 'setupAssessorId') === 0

    errors.setupAssessorId = required(get(values, 'setupAssessorId'))

    if (isNoneOfTheseSubCategory) {
      errors.assessorTitle = required(get(values, 'assessorTitle'))
      errors.assessorName = required(get(values, 'assessorName'))
      errors.assessorEmail = required(get(values, 'assessorEmail'))
      errors.assessorPhone = required(get(values, 'assessorPhone'))
      errors.assessorRelevantExperience = required(get(values, 'assessorRelevantExperience'))
    }
  }

  return errors
}

export default validate
